import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { Link } from 'react-router-dom';
import { message } from 'kts-platform-frame/api';
import { connect } from 'kts-platform-frame/redux';
import { AppKey } from 'kts-platform-frame/entry/constant';
import { NodeEnvType } from 'kts-platform-frame/entry/constant';
import { IAppInfo } from 'kts-platform-frame/dataModel';
import { Menu, Icon, Badge } from 'antd';
import { withRouter } from 'kts-platform-frame/routes';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';

const css = require('./index.scss');

/** Redux接口 */
interface IReduxStatePart {
    NODE_ENV?: NodeEnvType;
    appList?: IAppInfo[];
    messageUnread?: number;
}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {
}

/** 基础功能- */
@withRouter
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({
    NODE_ENV: state.env.NODE_ENV,
    appList: [],//state.user.appList,
    messageUnread: state.system.messageUnread,
}))
export default class UIFeatures extends UIBasic<IProps, ModulesState> {

    constructor(props: IProps) {
        super(props, ModulesAction);
    }

    componentDidMount() {
        message.messageCountUnread(this);
    }

    render() {
        const { location, NODE_ENV } = this.props;
        return (
            <Menu
                theme="dark"
                mode="inline"
                selectedKeys={[ModulesAction.getMenuSelectedKeys(location.pathname)]}
                inlineCollapsed={this.modulesState.collapsed}
                inlineIndent={15}
                className={css.features}
            >
                <Menu.Item key="/workbench/myApp">
                    <Link to="/workbench/myApp">
                        <Icon type="yingyong3" />
                        <span>我的应用</span>
                    </Link>
                </Menu.Item>
                {
                    ModulesAction.isInstallApp(AppKey.消息) &&
                    <Menu.Item key={`/workbench/m/${AppKey.消息}`}>
                        <Link to={`/workbench/m/${AppKey.消息}`}>
                            <Icon type="xinxiang" />
                            <span>
                                消息
                                {
                                    this.props.messageUnread > 0 &&
                                    <Badge style={{ paddingLeft: 12 }} status="error" />
                                }
                            </span>
                        </Link>
                    </Menu.Item>
                }
                {
                    ModulesAction.isInstallApp(AppKey.开发测试) &&
                    <Menu.Item key={`/workbench/m/debugging`}>
                        <Link to={`/workbench/m/debugging`}>
                            <Icon type="shezhi" />
                            <span>开发环境APP测试</span>
                        </Link>
                    </Menu.Item>
                }
                {
                    ModulesAction.isInstallApp(AppKey.商品) &&
                    <Menu.Item key={`/workbench/m/${AppKey.商品}`}>
                        <Link to={`/workbench/m/${AppKey.商品}`}>
                            <Icon type="shangpinshenqing" />
                            <span>商品管理</span>
                        </Link>
                    </Menu.Item>
                }
                {
                    ModulesAction.isInstallApp(AppKey.任务中心) &&
                    <Menu.Item key={`/workbench/m/${AppKey.任务中心}`}>
                        <Link to={`/workbench/m/${AppKey.任务中心}`}>
                            <Icon type="shoujianxiang" />
                            <span>任务中心</span>
                        </Link>
                    </Menu.Item>
                }
                {
                    ModulesAction.isInstallApp(AppKey.网络) &&
                    <Menu.Item key="/workbench/platform/network/userlist">
                        <Link to="/workbench/platform/network/userlist">
                            <Icon type="relationship" />
                            <span>网络</span>
                        </Link>
                    </Menu.Item>
                }
                {
                    ModulesAction.isInstallApp(AppKey.单据) &&
                    <Menu.Item key={`/workbench/m/${AppKey.单据}`}>
                        <Link to={`/workbench/m/${AppKey.单据}`}>
                            <Icon type="wendang" />
                            <span>单据</span>
                        </Link>
                    </Menu.Item>
                }
                {
                    ModulesAction.isInstallApp(AppKey.APP商店) &&
                    <Menu.Item key={`/workbench/m/${AppKey.APP商店}`}>
                        <Link to={`/workbench/m/${AppKey.APP商店}`}>
                            <Icon type="yingyong" />
                            <span>应用商店</span>
                        </Link>
                    </Menu.Item>
                }
            </Menu>
        );
    }
}



// WEBPACK FOOTER //
// ./src/display/modules/Home/Workbench/UI.Features.tsx